import { ReactNode } from "react";

import Grid from "@mui/material/Grid";

import styles from './HomepageHeaderContainer.module.css';

const HomepageHeaderContainer = ({ children }: { children: ReactNode }) => <Grid className={styles.container}>{children}</Grid>;

export default HomepageHeaderContainer